import type { TranslationFunction } from "@src/packages/i18n";
import type {
  ResultCyclePhase,
  ResultInterpretationContext,
} from "@src/packages/test-results/interpretation-context";
import type { FactSheetContextRow } from "./FactSheetContextCard";

const RESULT_PHASE_LABEL_KEYS: Record<ResultCyclePhase, string> = {
  baseline: "care.lab_result.context_baseline",
  follicular: "care.lab_result.context_follicular",
  stimulation: "care.lab_result.context_stimulation",
  ovulatory: "care.lab_result.context_ovulatory",
  luteal: "care.lab_result.context_luteal",
  unknown: "care.lab_result.context_unknown",
};

function formatFallbackLabel(value: string) {
  return value
    .replace(/_/g, " ")
    .replace(/\b\w/g, (character) => character.toUpperCase());
}

function getTreatmentPhaseLabel(phase: string | null, t: TranslationFunction) {
  if (!phase) return t("care.lab_result.context_unknown");
  const key = `care.phase_type.${phase}`;
  const translated = t(key);
  return translated === key ? formatFallbackLabel(phase) : translated;
}

export function getInterpretationContextRows(
  context: ResultInterpretationContext,
  t: TranslationFunction,
): FactSheetContextRow[] {
  return [
    {
      label: t("care.lab_result.context_cycle_day"),
      value:
        context.cycleDay === null
          ? t("care.lab_result.context_unknown")
          : t("care.lab_result.context_day_value", {
              params: { day: String(context.cycleDay) },
            }),
    },
    {
      label: t("care.lab_result.context_cycle_phase"),
      value: t(RESULT_PHASE_LABEL_KEYS[context.cyclePhase]),
    },
    {
      label: t("care.lab_result.context_treatment_phase"),
      value: getTreatmentPhaseLabel(context.treatmentPhase, t),
    },
    {
      label: t("care.lab_result.context_used"),
      value: t(RESULT_PHASE_LABEL_KEYS[context.usedContext]),
    },
  ];
}
